import uajs from './module/ua';
// 共通

(function ($) {
	const ua = uajs();

	$(document).ready(function () {

		// アンカーリンク
		$('a[href*="#"]').click(function (e) {
			const href = $(this).attr('href');
			if (href.match(/^#/) && $(href).length > 0) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(href).offset().top
				}, 'fast');
				return false;
			}
		});

		// 優秀賞
		$(function () {
			// episode slick
			const $slider = $(".js_slider");
			// 左右の透過の2周目ががたつく対応
			$slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
				$slider.find(".slick-slide").each((index, el) => {
					const $this = $(el),
						slickindex = $this.attr("data-slick-index");
					if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
						if (slickindex == "-1") {
							$this.addClass("is-active-next");
						} else {
							$this.removeClass("is-active-next");
						}
					} else if (nextSlide == 0) {
						if (slickindex == slick.slideCount) {
							$this.addClass("is-active-next");
						} else {
							$this.removeClass("is-active-next");
						}
					} else {
						$this.removeClass("is-active-next");
					}
				});
			});

			// SPのみslider
			function checkBreakPoint() {
				w = $(window).width();
				if (w <= 767) {
					$slider.not('.slick-initialized').slick({
						slidesToScroll: 1,
						arrows: true,
						autoplay: true,
						dots: false,
						infinite: true,
						centerMode: true,
						centerPadding: '14%',
						pauseOnFocus: false,
						speed: 600
					});
				} else {
					$('.js_slider.slick-initialized').slick('unslick');
				}
			}
			// slickウインドウがリサイズする度にチェック
			$(window).resize(function () {
				checkBreakPoint();
			});
			// slick初回チェック
			checkBreakPoint();

		})


		// 最優秀賞
		$(function () {
			const $slider02 = $(".js_slider-02");
			// 左右の透過の2周目ががたつく対応
			$slider02.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
			  $slider02.find(".slick-slide").each((index, el) => {
			    const $this = $(el),
			      slickindex = $this.attr("data-slick-index");
			    if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
			      if (slickindex == "-1") {
			        $this.addClass("is-active-next");
			      } else {
			        $this.removeClass("is-active-next");
			      }
			    } else if (nextSlide == 0) {
			      if (slickindex == slick.slideCount) {
			         $this.addClass("is-active-next");
			      } else {
			        $this.removeClass("is-active-next");
			      }
			    } else {
			      $this.removeClass("is-active-next");
			    }
			  });
			});

			function checkBreakPoint() {
				w = $(window).width();
				if (w <= 767) {
					$('.js_slider-02').not('.slick-initialized').slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
						autoplay: true,
						dots: false,
						infinite: true,
						variableWidth: true,
						pauseOnFocus: false,
						speed: 600
					});
				} else {
					$('.js_slider-02.slick-initialized').slick('unslick');
				}
			}
			// slickウインドウがリサイズする度にチェック
			$(window).resize(function () {
				checkBreakPoint();
			});
			// slick初回チェック
			checkBreakPoint();
		})


	});

})(jQuery);

// 要素をふわっと表示
function showElementAnimation() {
  var element = document.getElementsByClassName('p_fadein');
  if(!element) return; // 要素がなかったら処理をキャンセル

  var showTiming = window.innerHeight > 750 ? 100 : 40; // 要素が出てくるタイミングはここで調整 750px以下は40px
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;

  for(var i=0;i<element.length;i++) { var elemClientRect = element[i].getBoundingClientRect(); var elemY = scrollY + elemClientRect.top; if(scrollY + windowH - showTiming > elemY) {
      element[i].classList.add('js_show');
    }
  }
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);
